"use strict";

exports.__esModule = true;
exports.getLastClosedMaintenanceTaskDate = exports.getDateText = void 0;
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getDate = function getDate(date, timezoneName) {
  return _momentTimezone["default"].utc(date).tz(timezoneName).format("ll");
};
var getLastClosedMaintenanceTaskDate = exports.getLastClosedMaintenanceTaskDate = function getLastClosedMaintenanceTaskDate(planData, timezoneName) {
  if (!planData.lastActivityClosedDate) {
    return "-";
  }
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "ComponentRemainingLife.Maintenance.LastClosedActivityDate",
    defaultMessage: "Last maintenance task closed: {date}",
    values: {
      date: getDate(planData.lastActivityClosedDate, timezoneName)
    }
  });
};
var getDateText = exports.getDateText = function getDateText(planData, timezoneName) {
  if (planData.activityState === "Pending") {
    if (planData.pendingAt) {
      return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ComponentRemainingLife.MaintenancePending.CreatedDate",
        defaultMessage: "Maintenance due since: {date}",
        values: {
          date: getDate(planData.pendingAt, timezoneName)
        }
      });
    } else {
      return /*#__PURE__*/_react["default"].createElement("tspan", {
        fontSize: 24
      }, "-");
    }
  } else {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ComponentRemainingLife.MaintenancePending.ExpectedDate",
      defaultMessage: "Maintenance predicted: {date}",
      values: {
        date: getDate(planData.expectedAt, timezoneName)
      }
    });
  }
};